import { FormControl, FormLabel, MenuItem, Select, Stack } from '@mui/material'
import { FC } from 'react'

import {
  AutomatedVehicleReminderInfoTimeframeEnum,
  VehicleReminderMessageInfoTypeEnum
} from '../../sdk'
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter/capitalizeFirstLetter'

interface Props {
  reminder: VehicleReminderMessageInfoTypeEnum
  setReminder: React.Dispatch<
    React.SetStateAction<VehicleReminderMessageInfoTypeEnum>
  >
  timeframe: AutomatedVehicleReminderInfoTimeframeEnum
  setTimeframe: React.Dispatch<
    React.SetStateAction<AutomatedVehicleReminderInfoTimeframeEnum>
  >
}

export const VehicleReminderFilterForm: FC<Props> = ({
  reminder,
  setReminder,
  timeframe,
  setTimeframe,
  ...props
}) => {
  return (
    <Stack direction="row" spacing={5} {...props}>
      <FormControl variant="outlined" sx={{ minWidth: 300 }}>
        <FormLabel id="reminder-type-label">Reminder Type</FormLabel>
        <Select
          labelId="reminder-type-label"
          id="reminder-type-select"
          value={reminder}
          onChange={(event) => {
            setReminder(
              event.target.value as VehicleReminderMessageInfoTypeEnum
            )
          }}
          sx={{ mt: 1 }}>
          {Object.entries(VehicleReminderMessageInfoTypeEnum).map(
            ([key, value]) => (
              <MenuItem key={key} value={value}>
                {capitalizeFirstLetter(value.replaceAll(/_/g, ' '))}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>

      <FormControl variant="outlined" sx={{ minWidth: 300 }}>
        <FormLabel id="timeframe-label">Select Timeframe</FormLabel>
        <Select
          labelId="timeframe-label"
          id="timeframe-select"
          value={timeframe}
          onChange={(event) => {
            setTimeframe(
              event.target.value as AutomatedVehicleReminderInfoTimeframeEnum
            )
          }}
          sx={{ mt: 1 }}>
          {Object.entries(AutomatedVehicleReminderInfoTimeframeEnum).map(
            ([key, value]) => (
              <MenuItem key={key} value={value}>
                {value.replaceAll(/_/g, ' ')}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Stack>
  )
}
